import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link) => {
        // this.setState({ showModal: true, selectedService: service, paymentLink: link });

        // No need for the modal since mainstack collects user data
        // Redirect to payment page
        window.open(link, "_blank");
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "The Resilient Professional",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
                    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">The Resilient Professional</h2>
                                    <p>Mastering Change and Driving Transformation</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content pb--80 align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/professional.jpeg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>In today's rapidly evolving professional landscape, mere survival is not enough. You need resilience, the ability to not just withstand change but to harness it for transformative career growth. This intensive course, "The Resilient Professional," provides seasoned professionals with the strategic tools and mindset shifts required to navigate uncertainty and drive impactful change.</p>

                                                    <h5 className="title mt-3">Why I Created This Course</h5>
                                                    <p>After decades of witnessing professionals struggle to adapt to constant change, I saw a critical gap. Too often, we focus on technical skills, neglecting the essential resilience needed to thrive. This course is my response – a practical, results-driven Program designed to equip you with the strategies to not just survive, but flourish in today's dynamic workplace.</p>

                                                    
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title">Course Curriculum</h5>
                                                    <ul className="liststyle">
                                                        <li>Module 1: Foundations of Resilience Thinking: Understanding the psychology of resilience and developing a proactive mindset.</li>
                                                        <li>Module 2: Strategic Change Navigation: Practical frameworks for anticipating, adapting to, and leading change.</li>
                                                        <li>Module 3: Driving Impactful Transformation: Techniques for identifying opportunities and implementing transformative strategies.</li>
                                                        <li>Module 4: Cultivating a Robust Career: Building a future-proof career by mastering adaptability and continuous growth.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">In this course, you will learn how to:</h5>
                                                    <ul className="liststyle">
                                                        <li>Develop a resilient mindset to navigate uncertainty.</li>
                                                        <li>Implement practical change navigation strategies.</li>
                                                        <li>Drive transformative initiatives within your organisation.</li>
                                                        <li>Future-proof your career in a dynamic market.</li>
                                                        <li>Cultivate a robust and adaptable professional identity.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">What will you gain?</h5>
                                                    <p>By the end of this course, you will have the tools and confidence to:</p>
                                                    <ul className="liststyle">
                                                        <li>A personalised resilience action plan.</li>
                                                        <li>A toolkit of practical change management strategies.</li>
                                                        <li>The ability to identify and capitalise on transformative opportunities.</li>
                                                        <li>A renewed sense of confidence and control over your career trajectory.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">How is the course structured?</h5>
                                                    <p>This is an intensive ten-week online course, you can go at your own pace. The course features live interactive sessions, practical exercises, and personalised feedback. You will also receive access to a comprehensive resource library.</p>

                                                    <h5 className="title mt-3">FAQs:</h5>
                                                    <ol className="liststyle">
                                                        <li>Is this course suitable for my industry?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, the principles of resilience and change management are universally applicable across all industries.</p>

                                                        <li>How much time commitment is required?</li>
                                                        <p style={{ listStyle: 'none' }}>Expect to dedicate approximately two hours per week to live sessions and independent study.</p>

                                                        <li>Will I receive personalised feedback?</li>
                                                        <p style={{ listStyle: 'none' }}>Absolutely. You will receive detailed feedback on your assignments and have the opportunity for one-on-one consultations.</p>
                                                    </ol>

                                                    <div className="flex-wrap mt-5 align-items-center">
                                                        <h5 className="title mb-0 mr-3">Enrol Now £499</h5>

                                                        <div
                                                            className="payment-buttons btn btn-outline-danger d-inline-flex align-items-center px-3 py-2"
                                                            onClick={() => this.handlePaymentClick("The Resilient Professional", "https://mainstack.store/coachdoi/-_PnwAc6wOLl")}
                                                            style={{ cursor: "pointer", borderRadius: "4px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>Pay with </span>
                                                            <img
                                                                src="/assets/images/icons/mainstack.png"
                                                                alt="Mainstack"
                                                                className="btn-icon ml-2 img-fluid"
                                                                style={{ height: "20px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;